import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const HIFILogo = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/hifi-logo-black.png" style={style} />
}
